import BaseComponent from "@js/components/base_component.jsx";
import EuiIndexSearchBar from "@js/components/eui/index_search_bar.jsx";
import EuiSendingDomainsIndexTable from "@js/components/eui/sending_domains/index_table.jsx";

class EuiSendingDomainsIndex extends BaseComponent {

  render() {
    const table = this.props.sending_domains;
    const filtered = !!( this.props.q || this.props.dns_state || this.props.sending_enabled_filter );

    return (
      <div>
        <EuiIndexSearchBar
          q={ this.props.q }
          placeholder={ I18n.t("phrases.search_sending_domains") }
          indexPath={ Routes.eui_sending_domains_path }
          filters={ [
            {
              name: "dns_state",
              value: this.props.dns_state,
              blankLabel: I18n.t("blank_options.dns_state"),
              options: [
                { value: "not_verified", label: I18n.t("dns_state_filters.not_verified") },
                { value: "verified_good", label: I18n.t("dns_state_filters.verified_good") },
                { value: "verified_regressed", label: I18n.t("dns_state_filters.verified_regressed") },
              ],
            },
            {
              name: "sending_enabled",
              value: this.props.sending_enabled_filter,
              blankLabel: I18n.t("blank_options.sending_enabled"),
              options: [
                { value: "true", label: I18n.t("sending_enabled_filters.true") },
                { value: "false", label: I18n.t("sending_enabled_filters.false") },
              ],
            },
          ] }
        />

        <Panel heading="sending_domains">
          <EuiSendingDomainsIndexTable
            table={ table && table.data }
            library={ this.props.library }
            filtered={ filtered }
          />
          {table && table.total > 0 && <Paginator entity={table} />}
        </Panel>
      </div>
    );
  }

}

export default EuiSendingDomainsIndex;
